import { IMG } from "@/lib/site";
import Reveal from "@/components/site/Reveal";
import SectionCTA from "@/components/site/SectionCTA";
import useSeo from "@/lib/useSeo";
import { useT } from "@/lib/i18n";

const MiHistoria = () => {
  const t = useT();
  useSeo({
    title: {
      es: "Marta Montardit · Mi Historia | Método TAO by Marta",
      ca: "Marta Montardit · La meva història | Mètode TAO by Marta",
    },
    description: {
      es: "Tras superar un cáncer mientras me formaba como profesora de yoga, creé Método TAO para acompañar a quienes transitan procesos oncológicos, fibromialgia o dolor crónico.",
      ca: "Després de superar un càncer mentre em formava com a professora de ioga, vaig crear el Mètode TAO per acompanyar qui transita processos oncològics, fibromiàlgia o dolor crònic.",
    },
    path: "/mi-historia",
  });
  return (
    <div className="bg-ivory">
      <section className="pt-12 md:pt-20 pb-20 md:pb-24" data-testid="page-mi-historia">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
          <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
            <Reveal className="lg:col-span-5">
              <p className="text-[11px] tracking-[0.32em] uppercase text-sage mb-6">{t("story.eyebrow")}</p>
              <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-charcoal leading-[0.98]">
                {t("story.title1")} <span className="italic text-terracotta">{t("story.title2")}</span>.
              </h1>
              <p className="mt-6 font-serif italic text-2xl text-charcoal/80">
                {t("story.italic")}
              </p>
            </Reveal>
            <Reveal delay={0.1} className="lg:col-span-7">
              <div className="aspect-[4/5] rounded-tr-[5rem] rounded-bl-[5rem] overflow-hidden bg-sand">
                <img
                  src={IMG.storyPortrait}
                  alt="Marta Montardit"
                  className="w-full h-full object-cover object-[center_25%]"
                  fetchPriority="high"
                  decoding="async"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-24 bg-sand/30 grain">
        <div className="max-w-3xl mx-auto px-6 md:px-12 space-y-7 text-charcoal/85 text-lg leading-relaxed font-light">
          <Reveal>
            <p>{t("story.p1")}</p>
          </Reveal>
          <Reveal delay={0.05}>
            <p>{t("story.p2")}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-serif italic text-2xl md:text-3xl text-charcoal leading-snug pt-4">
              {t("story.p3")}
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p>{t("story.p4")}</p>
          </Reveal>
        </div>
      </section>

      <SectionCTA
        title={t("story.ctaTitle")}
        body={t("story.ctaBody")}
      />
    </div>
  );
};

export default MiHistoria;
